import {
  Box,
  Center,
  Container,
  Heading,
  Image,
  SimpleGrid,
  Text
} from "@chakra-ui/react"

const benefits = [
  {
    icon: "/images/icon1.svg",
    title: "Boost property value and long-term performance",
    description: "with energy-efficient upgrades",
    imgProps: { h: "90px" }
  },
  {
    icon: "/images/icon2.svg",
    title: "Use retrofit intelligence",
    description: "to make better asset decisions and unlock funding",
    imgProps: { h: "90px" }
  },
  {
    icon: "/images/icon3.svg",
    title: "Reduce operating, maintenance, and compliance costs",
    description: "",
    imgProps: { h: "90px" }
  },
  {
    icon: "/images/icon4.svg",
    title: "Future-proof your portfolio",
    description: "with full EPC and regulatory alignment",
    imgProps: { h: "60px" }
  },
  {
    icon: "/images/icon5.svg",
    title: "Eliminate energy bills",
    description: "and improve affordability for your tenants",
    imgProps: { w: "60px" }
  },
  {
    icon: "/images/icon6.svg",
    title: "Keep tenants longer",
    description: "with more comfortable, healthier homes",
    imgProps: { w: "60px" }
  }
]

const Benefits: React.FC = () => (
  <Box bg="white">
    <Container maxW="container.sm" pt={20} pb={40}>
      <Heading
        as="h2"
        size={["2xl", "3xl", "4xl"]}
        textAlign="center"
        mb={[12, 16, 24]}
        color="green.800"
      >
        Why use GreenFlip for your next retrofit investment?
      </Heading>

      <SimpleGrid columns={[1, 2, 3]} gap={[6, 8, 12]}>
        {benefits.map((b, i) => (
          <Box key={b.title} bg="gray.50" p={[4, 5, 6]} borderRadius="3xl">
            <Center pb={[4, 5, 6]}>
              <Image src={b.icon} alt="Greenflip" {...b.imgProps} />
            </Center>
            <Text textAlign="center" fontSize={["lg", "xl"]}>
              <strong>{b.title}</strong> {b.description}
            </Text>
          </Box>
        ))}
      </SimpleGrid>
    </Container>
  </Box>
)

export default Benefits
